import { MrIcon } from '@/components/Title/MrIcon';
import { MsIcon } from '@/components/Title/MsIcon';
import { E_CustomerTitle } from '@/types/Shopify';

export const TITLE_OPTIONS = {
  [E_CustomerTitle.MR]: MrIcon,
  [E_CustomerTitle.MS]: MsIcon,
};
